import { createRouter, createWebHistory } from "vue-router";

import SpecialIndex from "@/view/SpecialIndex";

// 特惠套餐订单查询
import SpecialOrderQuery from "../view/SpecialOrderQuery";

const routes = [
    {
        path: "/",
        component:SpecialIndex

    },

    {
        path: "/proxy/:source",
        component:SpecialIndex

    },

    {
        path: "/special/:source",
        component:SpecialIndex
    },
    {
        path: "/:source",
        component:SpecialIndex

    },
    /*都是59元星卡标品落地页 映射路径不同 开始*/
    {
        path: "/ad/telcom59/:source",
        component:SpecialIndex
    },
    {
        path: "/ad/telcom5995/:source",
        component:SpecialIndex
    },
    {
        path: "/ad/telcom5955/:source",
        component:SpecialIndex
    },
    // 阿里小程序专属链接
    {
        path: "/ad/telcom5995ali/:source",
        component: SpecialIndex

    },
    /*都是59元星卡标品落地页 映射路径不同 结束*/



    {
        path: "/ad/telcom5995/offline/:source",
        component: SpecialIndex

    },
    {
        path: "/ad/Telcom5995ks/:source",
        component: SpecialIndex

    },
    {
        path: "/ad/Telcom5950kshaoma/:source",
        component: SpecialIndex

    },
    {
        path: "/ad/unicom/:source",
        component: SpecialIndex

    },{
        path: "/ad/unicomtwk/:source",
        component: SpecialIndex

    },{
        path: "/ad/unicomtwk220715/:source",
        component: SpecialIndex
    },{
        path: "/proxy/ad/unicomtwk/:source",
        component: SpecialIndex

    },{
        path: "/ad/unicomtwk_ks/:source",
        component: SpecialIndex
    },
    {
        path: "/ad/unicomtwk_ks52/:source",
        component: SpecialIndex

    },{
        path: "/ad/unicomtwk_ksxw/:source",
        component: SpecialIndex

    },
    {
        path: "/ad/unicomtwknomsg/:source",
        component: SpecialIndex

    },

    /* 线上代理 星卡 链接全部使用 只查询绍兴号码 开始 */
    {
        path: "/proxy/ad/telcomsx/:source",
        component: SpecialIndex
    },
    {
        path: "/ad/telcom59proxy/:source",
        component: SpecialIndex,
        meta:{
            title: '电信星卡免费领取还包邮'
        }
    },
    {
        path: "/ad/telcom5995proxy/:source",
        component: SpecialIndex
    },
    {
        path: "/ad/telcomsx/:source",
        component:  SpecialIndex
    },

    {
        path: "/ad/specialorder/query",
        component:SpecialOrderQuery,
        meta:{
            title: '订单查询'
        }
    },

    {
        path: "/proxy/ad/mobileflower/:source",
        component:  SpecialIndex,
    },

    {
        path: "/ad/mobileflower/:source",
        component:  SpecialIndex
    },

    {
        path: "/ad/unicommagic/:source",
        component: SpecialIndex
    }
    ,
    {
        path: "/ad/:area/:source",
        component: SpecialIndex

    },

    {
        path: "/ad/mobileflowernomsg/:source",
        component: SpecialIndex

    }

];

const router = createRouter({
    history: createWebHistory('/ad-web'),
    routes
});

export default router;
